import React, { useState } from "react";
import Select from "react-select";
import {

    FormGroup,
    Label,

} from "reactstrap";


const fontStyles = [
    { label: "Normal", value: "normal" },
    { label: "Italic", value: "italic" },
    // { label: "Oblique", value: "oblique" },
  ];

function FontStyleSelector({ selectedFontStyle, onChange,...props }) {


    return <div>
        <Label for="fontStyle">Font Style</Label>
        <Select
            value={selectedFontStyle}
            onChange={(e) => {
                if (e) {
                    onChange(e.value)
                } else {
                    onChange("")
                }
            }}
            options={fontStyles}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            {...props}
        />
    </div>
}

export default FontStyleSelector